import Dropzone from '../../../node_modules/dropzone/index';

/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 02/16/2016
 * Time: 2:24 PM
 *
 * The widget for a File Upload control
 */
(function($) {
    $.widget('ca.caFileUpload', {
        options: {
            url: '/mail/upload-with-ext'
        },

        _create: function () {
            var self = this;

            Dropzone.autoDiscover = false;
            this.element.dropzone({
                url: self.options.url,
                paramName: "attachment",
                success: function(response) {
                    var attachment = '{"attachment":' + response.xhr.response + '}';
                    self.element.append('<input name="attachments[]" type="hidden" value=\'' + attachment + '\'>');
                }
            });
        }
    });
})(jQuery);
